export const handleSelectedFilesValidation = ({ selectedFilesCount, selectedFilesSize, maxFilesCount, maxFilesSize, }) => {
    const isMaxFilesCountExceeded = selectedFilesCount > maxFilesCount;
    const isMaxFilesSizeExceeded = selectedFilesSize > maxFilesSize;
    return { isMaxFilesCountExceeded, isMaxFilesSizeExceeded };
};
